import useFormApi from '@form-engine/builder-application/hooks/use-form-api';
import { useEffect } from 'react';

export default function useFormStaleHandler(
    currentForm: FormDefinition,
    handler: (newForm: FormDefinition) => Promise<void>,
    pollRate = 5000
) {
    const { list, retrieve } = useFormApi();
    const { id, updatedAt } = currentForm;

    useEffect(() => {
        let mounted = true;
        let currentTimeout: ReturnType<typeof setTimeout>;

        async function poll() {
            if (!mounted || !id) {
                return;
            }

            const [dbFormState] = (await list({
                attributes: ['id', 'updatedAt'],
                limit: 1,
                filter: { id },
            })) as FormDefinition[];

            if (
                dbFormState?.updatedAt &&
                updatedAt &&
                new Date(dbFormState?.updatedAt) > new Date(updatedAt)
            ) {
                await handler(await retrieve(id));
            }

            if (!mounted) {
                return;
            }

            currentTimeout = setTimeout(poll, pollRate);
        }

        poll();

        return () => {
            mounted = false;
            clearTimeout(currentTimeout);
        };
    }, [id, updatedAt, handler, pollRate, list, retrieve]);
}
